import { colors, sizes } from '@lmc/common/constants'
import { EmptyState, NotStartedIcon } from '@lmc/ui-kit'
import { find } from 'lodash'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Actions from '../../../actions'
import { getNominative, showToast } from '../../../common/utils'
import { IconSectionHeader } from '../../../components/generic'
import ConfirmationDialog from '../../../LEGACY/ConfirmationDialog'
import Operations from '../../../operations'
import { withRouter } from '../../../withRouter'
import MedicationItem from '../components/MedicationItem'

export class ResidentMedicationsDashboardScreen extends PureComponent {
  state = {
    medicationToDelete: null
  }

  componentDidMount() {
    this.props.fetchMedications()
  }

  componentDidUpdate(prevProps) {
    const {
      fetchMedications,
      router: { params }
    } = this.props
    if (
      prevProps.router.params &&
      params &&
      prevProps.router.params.id !== params.id
    ) {
      fetchMedications()
    }
  }

  closeDeleteDialog = () => {
    this.setState({ medicationToDelete: null })
  }

  deleteMedication = () => {
    this.props.deleteMedication(this.state.medicationToDelete, () => {
      showToast({ type: 'info', title: 'Deleted a Medication' })
      this.closeDeleteDialog()
    })
  }

  handleDelete = (id) => {
    this.setState({ medicationToDelete: id })
  }

  renderBackLink = () => (
    <Link to={`/residents/${this.props.router.params.id}/profile`}>
      <span className="octicon octicon-chevron-left" /> Back
    </Link>
  )

  renderHeader = () => {
    const { resident, openCreateModal } = this.props
    return (
      <div>
        <IconSectionHeader
          icon="medication"
          color={colors.blue}
          title={`${resident.name.first} ${resident.name.last}'s Medication`}
          buttonId="add-medication"
          buttonLabel="Add Medication"
          buttonType="add"
          isMainHeader
          onClickButton={openCreateModal}
        />
      </div>
    )
  }

  render() {
    const {
      features,
      medications,
      openEditModal,
      router: { params },
      resident,
      preferredPeopleNominative
    } = this.props

    if (
      !features ||
      !features.carePlans ||
      !medications ||
      !params ||
      !resident
    ) {
      return null
    }

    return (
      <div style={styles.wrapper}>
        {this.renderBackLink()}
        <div style={styles.mainContainer}>
          {this.renderHeader()}
          {medications.length ? (
            medications.map((medication) => (
              <div key={medication.id} style={styles.medicationContainer}>
                <MedicationItem
                  medication={medication}
                  onDelete={this.handleDelete}
                  onEdit={openEditModal}
                />
              </div>
            ))
          ) : (
            <div style={styles.medicationContainer}>
              <EmptyState
                title={`You haven't added any medications for this ${getNominative(
                  preferredPeopleNominative,
                  'resident'
                )}`}
                icon={<NotStartedIcon />}
                description={NO_MEDICATIONS}
              >
                <a href={SUPPORT_ARTICLE} rel="noreferrer" target="_blank">
                  Find out more
                </a>
              </EmptyState>
            </div>
          )}
        </div>
        <ConfirmationDialog
          isOpen={!!this.state.medicationToDelete}
          onCancel={this.closeDeleteDialog}
          onConfirmation={this.deleteMedication}
          confirmationType="warning"
        >
          {getConfirmationBody(preferredPeopleNominative)}
        </ConfirmationDialog>
      </div>
    )
  }
}

const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/3417397-medication-list'
const NO_MEDICATIONS =
  "Add medications so they're viewable here and on the Carer App."
const getConfirmationBody = (preferredPeopleNominative) =>
  `Are you sure you want to delete this medication for this ${getNominative(
    preferredPeopleNominative,
    'resident'
  )}?`

const CREATE_MODAL_ID = 'addMedication'
const EDIT_MODAL_ID = 'editMedication'

const styles = {
  link: {
    marginLeft: 5
  },
  mainContainer: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    paddingTop: 30
  },
  infoSection: {
    textAlign: 'center',
    marginTop: 14,
    fontSize: 14,
    padding: 18,
    lineHeight: '20px'
  },
  infoLink: {
    marginLeft: 5,
    textDecoration: 'none',
    color: colors.pink
  },
  medicationContainer: {
    marginTop: 24
  },
  wrapper: {
    padding: '20px 0px 50px'
  }
}

ResidentMedicationsDashboardScreen.propTypes = {
  deleteMedication: PropTypes.func.isRequired,
  fetchMedications: PropTypes.func.isRequired,
  medications: PropTypes.array,
  openCreateModal: PropTypes.func.isRequired,
  resident: PropTypes.object
}

const mapStateToProps = (state, props) => ({
  features: state.global.home,
  medications: state.data.medications,
  resident: find(state.data.residents, { id: props.router.params.id }),
  preferredPeopleNominative: state.global.home.preferredPeopleNominative
})

const mapDispatchToProps = (dispatch, props) => ({
  deleteMedication: (id, onComplete) =>
    dispatch(
      Operations.deleteFormItem({
        id,
        list: 'medications',
        fetchQuery: {
          filters: { resident: props.router.params.id }
        },
        onComplete
      })
    ),
  fetchMedications: () =>
    dispatch(
      Operations.loadList('medications', {
        filters: { resident: props.router.params.id }
      })
    ),
  openCreateModal: () => {
    dispatch(Actions.openModal({ modalId: CREATE_MODAL_ID }))
    dispatch(Actions.addForm({ formId: CREATE_MODAL_ID }))
  },
  openEditModal: (initial) => {
    dispatch(Actions.openModal({ modalId: EDIT_MODAL_ID }))
    dispatch(Actions.addForm({ formId: EDIT_MODAL_ID, initial }))
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ResidentMedicationsDashboardScreen)
)
